/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import { func, object, element, string, bool, oneOf, oneOfType, number } from "prop-types";
import Icon from "../Icon";

class SortableTableHeader extends React.Component {
  // = ({columnName, styling, children, isSortedIndex, isAscending, sortType, onClick}) => {
  handleKeyPress = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      this.props.onClick();
    }
  };

  render() {
    return (
      <th
        // role='columnheader'
        aria-hidden
        className={this.props.sortType === "notSortable" ? "" : "sortable"}
        title={this.props.columnName}
        aria-sort={
          this.props.isSortedIndex
            ? this.props.isAscending
              ? "ascending"
              : "descending"
            : "none"
        }
        style={this.props.styling}
        onClick={this.props.onClick}
        tabIndex={this.props.tabIndex}
      >
        <span tabIndex={this.props.tabIndex} onKeyDown={this.handleKeyPress}>
          {this.props.children}
          {this.props.sortType !== "notSortable" ? (
            this.props.isSortedIndex ? (
              this.props.isAscending ? (
                <Icon
                  fileName="sort-up-18"
                  title=" column sorted in ascending order"
                  name={this.props.columnName}
                  isHidden
                />
              ) : (
                <Icon
                  fileName="sort-down-18"
                  title="column sorted in descending order"
                  name={this.props.columnName}
                  isHidden
                />
              )
            ) : (
              <Icon
                fileName="sortable-18"
                title={this.props.columnName}
                name={this.props.columnName}
                isHidden
              />
            )
          ) : (
            ""
          )}
        </span>
      </th>
    );
  }
}

SortableTableHeader.propTypes = {
  columnName: string.isRequired,
  styling: object,
  children: element.isRequired,
  isSortedIndex: bool,
  isAscending: bool,
  tabIndex: oneOfType([string, number]),
  sortType: oneOf(["notSortable", "numeric", "string", "datetime"]).isRequired,
  onClick: func,
  isfrontEndSorting: bool,
};

SortableTableHeader.defaultProps = {
  isSortedIndex: false,
  isAscending: false,
};

export default SortableTableHeader;
